import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useThemeMode } from '../../ThemeContext';

// Import assets for ComplianceTeams section
import ChevronRight from '../../assets/chevron-right.svg';

function ComplianceTeams() {
  const { mode } = useThemeMode();

  return (
    <>
      {/* Testimonial Section - Hidden */}
      {false && (
        <section className="testimonial-section-2" id="about">
          <div className="testimonial-bg-gradient"></div>
          <Container className="testimonial-content">
            <div className="testimonial-header">
              <h2 className="testimonial-title">Trusted by Safety & Compliance Leaders</h2>
              <div className="testimonial-subtitle">From construction sites to childcare centres, from Not For Profits to local councils — Complimate gives teams confidence that their compliance is regulator-ready.</div>
            </div>
            <Row className="testimonial-cards-row d-flex flex-row flex-wrap justify-content-center">
              <Col className="d-flex justify-content-center" style={{ maxWidth: '600px', width: '100%' }}>
                <div className="testimonial-card-2 h-100 w-100">
                  <div className="testimonial-quote">"Complimate cut our audit time in half. The clause-cited reports and corrective action tracking mean we can walk into a Government or ISO audit with confidence."</div>
                  <div className="testimonial-author">Operations Manager, Civil Construction Company</div>
                </div>
              </Col>
              <Col className="d-flex justify-content-center" style={{ maxWidth: '600px', width: '100%' }}>
                <div className="testimonial-card-2 h-100 w-100">
                  <div className="testimonial-quote">"The child safety audit tool identified gaps we didn't even see. Complimate helped us close them quickly and gave us documents that parents and regulators trust."</div>
                  <div className="testimonial-author">Director, Early Learning Centre (NSW)</div>
                </div>
              </Col>
              <Col className="d-flex justify-content-center" style={{ maxWidth: '600px', width: '100%' }}>
                <div className="testimonial-card-2 h-100 w-100">
                  <div className="testimonial-quote">"Finally, compliance software that works the way we do. Complimate makes policies, tasks, and WHS roles easy to manage across our dispersed teams."</div>
                  <div className="testimonial-author">Program Manager, Indigenous Ranger Service</div>
                </div>
              </Col>
            </Row>
            <div className="testimonial-nav-row-2 d-flex justify-content-center mt-4">
              <Button className="testimonial-nav-btn-2" aria-label="Previous testimonial">
                <img src={ChevronRight} alt="Previous" style={{ transform: 'rotate(180deg)' }} />
              </Button>
              <Button className="testimonial-nav-btn-2" aria-label="Next testimonial">
                <img src={ChevronRight} alt="Next" />
              </Button>
            </div>
          </Container>
        </section>
      )}
    </>
  );
}

export default ComplianceTeams;
